module.exports = __webpack_public_path__ + "media/images/devenir-hote-instagram-1598c687c06429d0bc2d3c31fadbb675.webp";